import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  API,
  defaultLimitPagination,
  deleteCall,
  get,
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../config";
import {
  formatABN,
  formatMobile,
  formatName,
  formatPhone,
  formatSubcontractorName,
  getModuleNamingBySlug,
} from "../../lib/Misc";
import { debounce } from "lodash";
import MainBody from "../../components/MainBody/MainBody";
import BootstrapTable from "react-bootstrap-table-next";
import Pagination from "../../components/Pagination";
import { CaretDownIcon, CaretRightIcon } from "@radix-ui/react-icons";
import sortCaret from "../../components/SortCaret";
// import SyncXero from "../../components/SyncXero";
import UploadContact from "./UploadContact";
import AddEditContact from "./AddEditContact";
import { ResponsiveDrawerForm } from "../../components/ResponsiveDrawerForm";
import { LucidePlusCircle } from "lucide-react";
import ContactActionButton from "./ContactActionButton";
import Confirmation from "../../components/Confirmation";
import { useOrganization } from "../../lib/context/OrganisationContext";
import { cn } from "../../lib/utils";
import CommonFilters from "../../components/CommonFilters";
import ExpandContactTypeCDD from "../AML-CTF/CDD/ExpandContactTypeCDD";
import { useUser } from "../../lib/context/UserContext";
import { AMLCTFModuleConditonIndustry } from "../../lib/PermissionConditions";

const Contacts = ({ org = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { organizationData } = useOrganization();
  const { userData } = useUser();

  let amlCTFEnable =
    (userData?.email === "dchoradiya@gmail.com" ||
      organizationData?.organizationData?.is_aml_ctf_subscribed) &&
    AMLCTFModuleConditonIndustry(organizationData)
      ? true
      : false;

  const params = useParams();
  const trustId = params?.trust_id;

  const query = new URLSearchParams(location.search);
  const search = query.get("search");
  const defaultPage = query.get("page");
  const defaultLimit = query.get("limit");
  const [edit, setEdit] = useState(false);
  const [contractorsList, setContractorsList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [sortField, setSortField] = useState();
  const [sortOrder, setSortOrder] = useState();
  const [searchParam, setSearchParam] = useState(search || "");
  const [searchParamData, setSearchParamData] = useState(search || "");
  const [page, setPage] = useState(defaultPage || 1);
  const [limit, setLimit] = useState(defaultLimit || defaultLimitPagination);
  const [total, setTotal] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();

  // const builderId = localStorage.getItem("builderId")
  //   ? localStorage.getItem("builderId")
  //   : "";

  const [selectedRowIds, setSelectedRowIds] = useState([]);

  const [contactId, setContactId] = useState(null);
  const [showAddEditContact, setShowAddEditContact] = useState(false);
  const [showContactDelete, setShowContactDelete] = useState(false);

  const [amlCtfContactId, setAmlCtfContactId] = useState(org ? "1" : "");

  const [trustIds, setTrustIds] = useState();

  const toggleShowAddEditContact = () => {
    if (showAddEditContact) {
      setEdit(false);
      setContactId(null);
    }
    setShowAddEditContact(!showAddEditContact);
  };

  const toggleShowDelete = () => {
    if (showContactDelete) {
      setContactId(null);
    }
    setShowContactDelete(!showContactDelete);
  };

  const fetchContractors = useCallback(
    async (passLimit, passPage) => {
      try {
        setLoading(true);
        const { data } = await get(
          org
            ? `${API.GET_CONTACTS}?limit=${
                passLimit ? passLimit : limit ? limit : defaultLimitPagination
              }&page=${passPage ? passPage : page ? page : 1}&search=${
                searchParam ? searchParam : ""
              }&sort_column=${sortField ? sortField : ""}&sort_order=${
                sortOrder ? sortOrder : ""
              }&trust_ids=${trustIds ? trustIds : ""}&organization_id=${
                organizationData?.organizationId
              }&is_aml_ctf=${amlCtfContactId ? amlCtfContactId : ""}`
            : `${API.GET_CONTACTS}?limit=${
                passLimit ? passLimit : limit ? limit : defaultLimitPagination
              }&page=${passPage ? passPage : page ? page : 1}&search=${
                searchParam ? searchParam : ""
              }&sort_column=${sortField ? sortField : ""}&sort_order=${
                sortOrder ? sortOrder : ""
              }&trust_id=${trustId ? trustId : ""}`,
        );

        setLoading(false);
        setLimit(data?.data?.per_page);
        setPage(data?.data?.current_page);
        setTotal(data?.data?.total);
        setFrom(data?.data?.from);
        setTo(data?.data?.to);
        const contractorsList = data.data.data;
        let notSelectedIds = [];
        for (let i = 0; i < contractorsList?.length; i++) {
          notSelectedIds.push(contractorsList[i]?.id);
        }
        // setNotSelectedRowIds(notSelectedIds);
        setContractorsList(contractorsList);
        return data.data;
      } catch (error) {
        setLoading(false);
        setContractorsList([]);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      searchParam,
      sortOrder,
      sortField,
      trustId,
      trustIds,
      organizationData?.organizationId,
      amlCtfContactId,
    ],
  );

  const contractorsGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: contractorsList[i]?.id,
        expandData: contractorsList[i]?.contracts,
        code: contractorsList[i]?.code ? contractorsList[i]?.code : "",
        trust: contractorsList[i]?.trust
          ? formatSubcontractorName(contractorsList[i]?.trust)
          : "AML-CTF",
        name: formatName(
          contractorsList[i]?.first_name,
          contractorsList[i]?.last_name,
        ),
        joint_name: contractorsList[i]?.joint_accounts?.length
          ? formatSubcontractorName(contractorsList[i])
          : "-",
        email: contractorsList[i]?.email,
        abn: contractorsList[i]?.abn ? formatABN(contractorsList[i]?.abn) : "-",
        phone: contractorsList[i]?.phone
          ? formatPhone(contractorsList[i]?.phone)
          : "-",
        mobile: contractorsList[i]?.mobile
          ? formatMobile(contractorsList[i]?.mobile)
          : "-",
        business_name: contractorsList[i]?.business_name
          ? contractorsList[i]?.business_name
          : "-",
        contact_type: contractorsList[i]?.contact_type?.name
          ? contractorsList[i]?.contact_type?.name
          : "-",
        source: contractorsList[i]?.import_from
          ? contractorsList[i]?.import_from
          : "TrustSoft",
        kyc:
          contractorsList[i]?.kyc?.verifications?.length > 0
            ? [contractorsList[i]?.kyc]
            : [],

        action: (
          <>
            <ContactActionButton
              id={contractorsList[i]?.id}
              setEdit={setEdit}
              used={contractorsList[i]?.is_used ? true : false}
              setContactId={setContactId}
              toggleShowAddEditContact={toggleShowAddEditContact}
              toggleShowDelete={toggleShowDelete}
              trustId={trustId}
              contact={contractorsList[i]}
            />
          </>
        ),
      });
    }
    return items;
  };

  const contractors = contractorsGenerator(contractorsList?.length);

  const columns = org
    ? [
        {
          dataField: "trust",
          text: "Trust",
          sort: true,
          sortCaret,
          headerClasses: THClasses,
          classes: TDClasses,
        },
        {
          dataField: "code",
          text: "Code",
          sort: true,
          sortCaret,
          headerClasses: THClasses,
          classes: TDClasses,
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "name",
          text: "Name",
          sort: true,
          sortCaret,
        },
        {
          headerClasses: cn(
            THClasses,
            "whitespace-normal break-words", // fixed width + wrapping
          ),
          classes: cn(
            TDClasses,
            "whitespace-normal break-words", // fixed width + wrapping
          ),
          dataField: "joint_name",
          text: "Joint Name",
          sort: true,
          sortCaret,
        },
        {
          headerClasses: cn(
            THClasses,
            "whitespace-normal break-words", // fixed width + wrapping
          ),
          classes: cn(
            TDClasses,
            "whitespace-normal break-words", // fixed width + wrapping
          ),
          dataField: "business_name",
          text: "Business Name",
          sort: true,
          sortCaret,
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "email",
          text: "Email",
          sort: true,
          sortCaret,
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "abn",
          text: "ABN",
          // sort: true,
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "phone",
          text: "Phone No.",
          sort: true,
          sortCaret,
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "mobile",
          text: "Mobile No.",
          sort: true,
          sortCaret,
        },
        // {
        //   headerClasses: THClasses,
        //   classes: TDClasses,
        //   dataField: "contact_type",
        //   text: "Contact Type",
        // },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "source",
          text: "Source",
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "action",
          text: "Action",
          align: "center",
          headerAlign: "center",
          style: { width: "127px" },
        },
      ]
    : [
        {
          dataField: "code",
          text: "Code",
          sort: true,
          sortCaret,
          headerClasses: THClasses,
          classes: TDClasses,
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "name",
          text: "Name",
          sort: true,
          sortCaret,
        },
        {
          headerClasses: cn(
            THClasses,
            "whitespace-normal break-words", // fixed width + wrapping
          ),
          classes: cn(
            TDClasses,
            "whitespace-normal break-words", // fixed width + wrapping
          ),
          dataField: "joint_name",
          text: "Joint Name",
          sort: true,
          sortCaret,
        },
        {
          headerClasses: cn(
            THClasses,
            "whitespace-normal break-words", // fixed width + wrapping
          ),
          classes: cn(
            TDClasses,
            "whitespace-normal break-words", // fixed width + wrapping
          ),
          dataField: "business_name",
          text: "Business Name",
          sort: true,
          sortCaret,
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "email",
          text: "Email",
          sort: true,
          sortCaret,
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "abn",
          text: "ABN",
          // sort: true,
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "phone",
          text: "Phone No.",
          sort: true,
          sortCaret,
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "mobile",
          text: "Mobile No.",
          sort: true,
          sortCaret,
        },
        // {
        //   headerClasses: THClasses,
        //   classes: TDClasses,
        //   dataField: "contact_type",
        //   text: "Contact Type",
        // },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "source",
          text: "Source",
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "action",
          text: "Action",
          align: "center",
          headerAlign: "center",
          style: { width: "127px" },
        },
      ];

  const handleTableChange = (type, { page, sortField, sortOrder }) => {
    if (type === "sort") {
      setPage(1);
      setSortField(sortField);
      setSortOrder(
        sortOrder === "asc" ? "ASC" : sortOrder === "desc" && "DESC",
      );
    }
  };

  useEffect(() => {
    navigate(
      `?limit=${limit ? limit : defaultLimitPagination}&page=${
        page ? page : 1
      }&search=${searchParam ? searchParam : ""}&sort_column=${
        sortField ? sortField : ""
      }&sort_order=${sortOrder ? sortOrder : ""}`,
      {
        replace: true,
      },
    );
  }, [navigate, limit, searchParam, page, sortField, sortOrder]);

  useEffect(() => {
    fetchContractors();
  }, [fetchContractors]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSave = useCallback(
    debounce((nextValue) => {
      setSearchParam(nextValue);
      setPage(1);
    }, 300),
    [],
  );

  const handleSearchChange = (event) => {
    const { value: nextValue } = event.target;
    setSearchParamData(nextValue);
    setPage(1);
    debouncedSave(nextValue);
  };

  const handleClearSearch = () => {
    setSearchParamData();
    setSearchParam("");
  };

  const handleUpdateLimit = (e) => {
    const limit = e.target.value;
    setLimit(limit);
    setPage(1);
    fetchContractors(limit, 1);
  };

  const handleChangePage = (page) => {
    setPage(page);
    fetchContractors(limit, page);
  };

  const arrayRemove = (arr, value) => {
    return arr.filter(function (ele) {
      return ele !== value;
    });
  };

  const mainSelectRow = {
    mode: "checkbox",
    clickToSelect: false,
    classes: TDClasses,
    selected: selectedRowIds,
    // nonSelectable: xeroData?.connection_status === 1 ? [] : notSelectedRowIds,
    onSelectAll: (row, isSelect) => {
      if (contractorsList?.length > 0) {
        if (row) {
          const ids =
            isSelect &&
            isSelect?.length > 0 &&
            isSelect?.map((item) => {
              return item?.key;
            });
          setSelectedRowIds(selectedRowIds ? selectedRowIds.concat(ids) : ids);
        } else {
          const removableData =
            isSelect &&
            isSelect?.length > 0 &&
            isSelect.map(function (data) {
              return data?.key;
            });
          setSelectedRowIds(
            selectedRowIds
              ? selectedRowIds.filter((item) => !removableData.includes(item))
              : [],
          );
        }
      }
    },
    onSelect: (row, isSelect) => {
      if (isSelect) {
        setSelectedRowIds((keys) => [...keys, row?.key]);
      } else {
        setSelectedRowIds(arrayRemove(selectedRowIds, row?.key));
      }
    },
  };

  // Single COA Delete
  const handleContactDelete = async () => {
    try {
      setLoading(true);
      await deleteCall(`${API.CONTACT_DELETE}/${contactId}`);
      setLoading(false);
      fetchContractors(limit, page);
    } catch (error) {
      setLoading(false);
    }
  };

  // eslint-disable-next-line no-unused-vars
  const expandRow = {
    renderer: (row) => (
      <>
        <ExpandContactTypeCDD
          cddsList={row?.kyc}
          fetchCDDs={fetchContractors}
        />
      </>
    ),
    onlyOneExpanding: true,
    showExpandColumn: true,
    expandByColumnOnly: true,
    headerClasses: THClasses,
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <CaretDownIcon />;
      }
      return <CaretRightIcon />;
    },
    className: TDClasses,
    expandHeaderColumnRenderer: () => {
      return <></>;
    },
  };

  return (
    <>
      <MainBody
        searchParamData={searchParamData}
        handleClearSearch={handleClearSearch}
        handleSearchChange={handleSearchChange}
        mainTitle={getModuleNamingBySlug(
          organizationData?.organizationData,
          "contacts",
          "Customers",
        )}
        actionContent={
          // <div className="flex items-center gap-3 flex-wrap">
          <>
            {/* Sync Xero */}
            {/* <SyncXero
              builderId={builderId}
              selectedRow={selectedRowIds}
              setSelectedRow={setSelectedRowIds}
              trustId={trustId}
              fetchData={() => fetchContractors(limit, page)}
              recordId={contactId}
              setRecordId={setContactId}
              module="contact_ids"
              api={API.CONTACT_SYNC}
            /> */}

            {org && (
              <CommonFilters
                trust={org}
                trustId={trustIds}
                multiTrust={org}
                setTrustId={setTrustIds}
                aml_ctf_contact={true}
                amlCtfContactId={amlCtfContactId}
                setAmlCtfContactId={setAmlCtfContactId}
              />
            )}
            {/* Import Contact */}
            {/* {!org && ( */}
            <UploadContact
              fetchData={() => fetchContractors(limit, page)}
              trustId={trustId ? trustId : ""}
              ButtonName={"Import"}
              setLoading={setLoading}
              filter={
                org
                  ? `trust_ids=${trustIds ? trustIds : ""}&organization_id=${
                      organizationData?.organizationId
                    }&is_aml_ctf=${amlCtfContactId ? amlCtfContactId : ""}`
                  : `trust_id=${trustId ? trustId : ""}`
              }
            />
            {/* )} */}

            {/* Add Customer */}
            <ResponsiveDrawerForm
              description={""}
              title={
                edit
                  ? `Edit ${getModuleNamingBySlug(
                      organizationData?.organizationData,
                      "contacts",
                      "Customer",
                    )}`
                  : `Add ${getModuleNamingBySlug(
                      organizationData?.organizationData,
                      "contacts",
                      "Customer",
                    )}`
              }
              handleOpen={() => {}}
              handleClose={() => {
                setEdit(false);
                setContactId(null);
                setShowAddEditContact(false);
              }}
              buttonText={
                <div className="flex items-center gap-1">
                  <LucidePlusCircle size={18} />
                  <span>
                    Add{" "}
                    {getModuleNamingBySlug(
                      organizationData?.organizationData,
                      "contacts",
                      "Customer",
                    )}
                  </span>
                </div>
              }
              className={"overflow-hidden"}
              open={showAddEditContact}
              buttonClassName={""}
              setOpen={setShowAddEditContact}
              write={true}
            >
              <AddEditContact
                edit={edit}
                toggleShowAddEditContact={toggleShowAddEditContact}
                id={contactId}
                trustId={trustId}
                fetchContactData={() => fetchContractors(limit, page)}
              />
            </ResponsiveDrawerForm>
          </>
          // </div>
        }
        mainClassName="w-[calc(100%-3rem)]"
        loading={loading}
      >
        <div className="custom-table">
          <div className="table-body-class">
            {amlCTFEnable ? (
              <BootstrapTable
                keyField="key"
                remote
                data={contractors}
                // expandRow={expandRow}
                selectRow={mainSelectRow}
                columns={columns}
                onTableChange={handleTableChange}
                rowClasses={TRClasses}
                noDataIndication="No Data Found"
                classes={TableClasses}
                wrapperClasses={TableWrapClasses}
              />
            ) : (
              <BootstrapTable
                keyField="key"
                remote
                data={contractors}
                selectRow={mainSelectRow}
                columns={columns}
                onTableChange={handleTableChange}
                rowClasses={TRClasses}
                noDataIndication="No Data Found"
                classes={TableClasses}
                wrapperClasses={TableWrapClasses}
              />
            )}
          </div>

          <Pagination
            total={total}
            limit={parseInt(limit)}
            currentPage={page}
            updateLimit={handleUpdateLimit}
            updatePage={handleChangePage}
            from={from}
            to={to}
          />
        </div>
      </MainBody>

      <Confirmation
        title={`Delete ${getModuleNamingBySlug(
          organizationData?.organizationData,
          "contacts",
          "Customer",
        )}`}
        open={showContactDelete}
        setOpen={setShowContactDelete}
        toggleShow={() => {
          toggleShowDelete();
        }}
        className="sm:max-w-1/2"
        message={`Are you sure you want to delete ${getModuleNamingBySlug(
          organizationData?.organizationData,
          "contacts",
          "customer",
        )?.toLowerCase()}?`}
        okAction={async () => {
          handleContactDelete();
          toggleShowDelete();
          // fetchContractors();
        }}
        cancelAction={() => {
          setContactId(null);
          setShowContactDelete(!showContactDelete);
        }}
      />
    </>
  );
};

export default Contacts;
